import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Nav, Container, Burger } from './Styles';

class Header extends Component {
  static propTypes = {
    path: PropTypes.string.isRequired
  };

  state = {
    expanded: false
  };

  toggleNav = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  onLinkClick = () => {
    this.setState({ expanded: false });
  };

  render() {
    const { expanded } = this.state;
    const { path } = this.props;

    return (
      <Header.Nav>
        <Container>
          <Burger
            class="navbar-toggle collapsed"
            data-target="#navbarCollapse"
            data-toggle="collapse"
            onClick={this.toggleNav}
            type="button"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </Burger>
          <ul className={`${expanded ? 'expanded' : ''}`}>
            <li className={path === '/home' || path === '/' ? 'active' : ''}>
              <Link onClick={this.onLinkClick} to="/home">
                HOME
              </Link>
            </li>
            <li className={path.indexOf('/work') !== -1 ? 'active' : ''}>
              <Link disabled={path.indexOf('/work') !== -1} onClick={this.onLinkClick} to="/work">
                WORK
              </Link>
            </li>
            <li className={path.indexOf('/about') !== -1 ? 'active' : ''}>
              <Link disabled={path.indexOf('/about') !== -1} onClick={this.onLinkClick} to="/about">
                ABOUT
              </Link>
            </li>
            <li className={path.indexOf('/contact') !== -1 ? 'active' : ''}>
              <Link disabled={path.indexOf('/contact') !== -1} onClick={this.onLinkClick} to="/contact">
                CONTACT
              </Link>
            </li>
          </ul>
        </Container>
      </Header.Nav>
    );
  }
}
Header.Nav = Nav;
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js